import { render, staticRenderFns } from "./OrgChannelShare.vue?vue&type=template&id=42efb873"
import script from "./OrgChannelShare.vue?vue&type=script&lang=js"
export * from "./OrgChannelShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports